import ElRadioButton from './src/RadioButton.vue'

/* istanbul ignore next */
ElRadioButton.install = function (app) {
  app.component(ElRadioButton.name, ElRadioButton)
}

export { ElRadioButton }
